// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3lxBY","productName":"Table_productName__2NBv7"};